import React from 'react';
import { FileDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ScrollFadeIn } from './ScrollFadeIn';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden" style={{
    background: `
          repeating-linear-gradient(
            0deg,
            transparent,
            transparent 59px,
            rgba(14, 165, 233, 0.03) 59px,
            rgba(14, 165, 233, 0.03) 60px
          ),
          repeating-linear-gradient(
            90deg,
            transparent,
            transparent 59px,
            rgba(14, 165, 233, 0.03) 59px,
            rgba(14, 165, 233, 0.03) 60px
          ),
          radial-gradient(ellipse at 30% 20%, rgba(14, 165, 233, 0.08) 0%, transparent 50%),
          radial-gradient(ellipse at 70% 80%, rgba(15, 23, 41, 0.6) 0%, transparent 50%),
          linear-gradient(180deg, #0f1729 0%, #1a1d23 100%)
        `
  }} data-id="element-238">
      {/* Subtle corner accents */}
      <div className="absolute top-0 left-0 w-32 h-32 border-l-2 border-t-2 border-electric/10" data-id="element-239" />
      <div className="absolute bottom-0 right-0 w-32 h-32 border-r-2 border-b-2 border-electric/10" data-id="element-240" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-24 pb-16" data-id="element-241">
        <ScrollFadeIn data-id="element-242">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 mb-8 border border-slate-700/50 rounded-full bg-navy/40" data-id="element-243">
            <span className="w-1.5 h-1.5 rounded-full bg-electric animate-pulse" data-id="element-244" />
            <span className="text-xs font-medium uppercase tracking-widest text-slate-400" data-id="element-245">
              Power Logic Automation LLP
            </span>
          </div>
        </ScrollFadeIn>

        <ScrollFadeIn delay={100} data-id="element-246">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold uppercase tracking-tight leading-[1.1] text-white mb-6" data-id="element-247">
            {t('hero.headline')}
          </h1>
        </ScrollFadeIn>

        <ScrollFadeIn delay={200} data-id="element-248">
          <p className="max-w-2xl mx-auto text-base sm:text-lg text-slate-400 leading-relaxed mb-10" data-id="element-249">
            {t('hero.subheadline')}
          </p>
        </ScrollFadeIn>

        <ScrollFadeIn delay={300} data-id="element-250">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-251">
            <a href="#contact" className="inline-flex items-center justify-center px-8 py-3.5 bg-electric text-white font-semibold text-sm uppercase tracking-wider rounded hover:bg-sky-600 transition-colors duration-200 w-full sm:w-auto" data-id="element-252">
              {t('hero.cta.primary')}
            </a>
            <a href="#contact" className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border border-electric/50 text-electric font-semibold text-sm uppercase tracking-wider rounded hover:bg-electric/10 transition-colors duration-200 w-full sm:w-auto" data-id="element-253">
              {t('hero.cta.secondary')}
            </a>
          </div>
        </ScrollFadeIn>

        <ScrollFadeIn delay={400} data-id="element-254">
          <div className="inline-flex items-center gap-3 px-6 py-3 border border-slate-700/40 rounded-full bg-navy/30" data-id="element-255">
            <span className="w-2 h-2 rounded-full bg-electric" data-id="element-256" />
            <span className="text-sm font-medium text-slate-300 tracking-wide" data-id="element-257">
              {t('hero.credibility')}
            </span>
          </div>
        </ScrollFadeIn>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-graphite to-transparent" data-id="element-258" />
    </section>;
}